<template>
  <button v-if="showBackBtn" @click="backTo">
    Back
  </button>
</template>

<script>
export default {
  name: "BackButton",
  computed: {
    showBackBtn() {
      return this.$store.state.uiState.showBackBtn;
    },
  },
  methods: {
    backTo() {
      this.trackGoogleEvent(
        `Click ${this.backBtnText}`,
        "Back Button",
        this.backBtnText,
      );
      this.trackFacebookEvent(`Click ${this.backBtnText}`);

      if (this.$route.name === "short-summary") {
        if (this.$store.state.uiState.isViaShareLink) {
          this.$router.push("/?viaShare=true");
        } else {
          this.$router.push(`/products/${this.$store.state.products[0].type}`);
        }
      } else if (this.$route.name === "products") {
        let productIdx = this.$store.state.products.findIndex(
          (product) => product.type === this.$route.params.type,
        );

        if (productIdx === 0) {
          this.$router.push("/household");
        } else {
          this.$router.back();
        }
      } else if (this.$route.path === "/household") {
        this.$router.push("/");
      } else {
        this.$router.back();
      }
    },
  },
};
</script>
